if (!customElements.get('prime-cart-timer')) {
  customElements.define('prime-cart-timer', class extends HTMLElement {
    connectedCallback() {
      const key = 'snatched-cart-reserved-until';
      if (Number(this.dataset.count) === 0) {
        try { sessionStorage.removeItem(key); } catch {}
        this.hidden = true;
        return;
      }
      let deadline;
      try { deadline = Number(sessionStorage.getItem(key)); } catch {}
      if (!deadline) {
        deadline = Date.now() + 298000;
        try { sessionStorage.setItem(key, String(deadline)); } catch {}
      }
      const output = this.querySelector('[data-prime-countdown]');
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        output.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        if (!seconds) clearInterval(this.interval);
      };
      tick();
      this.interval = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}

(() => {
  const parseMoney = value => Number(value.replace(/[^0-9.-]/g, ''));
  const formatMoney = (value, template) => template.replace(/[0-9][0-9,]*(?:\.[0-9]+)?/, value.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
  const syncCheckout = () => {
    for (const id of ['CartDrawer', 'main-cart-footer']) {
      const root = document.getElementById(id);
      if (!root) continue;
      const total = root.querySelector('.totals__subtotal-value');
      const current = root.querySelector('.prime-checkout-current');
      const compare = root.querySelector('.prime-checkout-compare');
      const baseCurrent = root.querySelector('[data-prime-base-current]');
      const baseReference = root.querySelector('[data-prime-base-reference]');
      if (!total || !current || !baseCurrent || !baseReference) continue;
      const baseMoney = baseCurrent.querySelector('.money');
      let totalMoney = total.querySelector('.money');
      if (baseMoney && !totalMoney && /\bUSD\b/.test(total.textContent)) {
        totalMoney = document.createElement('span');
        totalMoney.className = 'money';
        totalMoney.textContent = total.textContent.replace(/\s*USD\b/, '').trim();
        total.replaceChildren(totalMoney);
        continue;
      }
      const baseCurrency = baseMoney?.getAttribute('bucks-currency');
      if (baseCurrency && totalMoney?.getAttribute('bucks-currency') !== baseCurrency) continue;
      const currentTemplate = baseCurrent.textContent.trim();
      const referenceTemplate = baseReference.textContent.trim();
      const displayedTotal = parseMoney(total.textContent);
      const adjustment = displayedTotal - parseMoney(currentTemplate);
      if (!Number.isFinite(displayedTotal) || !Number.isFinite(adjustment)) continue;
      const currentText = formatMoney(displayedTotal, currentTemplate);
      if (current.textContent !== currentText) current.textContent = currentText;
      if (compare) {
        const referenceText = formatMoney(parseMoney(referenceTemplate) + adjustment, referenceTemplate);
        if (compare.lastChild?.textContent !== referenceText) compare.lastChild.textContent = referenceText;
      }
    }
  };
  let pending;
  const observer = new MutationObserver(records => {
    if (!records.some(record => record.target.nodeType === 1 && record.target.closest?.('#CartDrawer, #main-cart-footer') || record.target.parentElement?.closest('#CartDrawer, #main-cart-footer'))) return;
    clearTimeout(pending);
    pending = setTimeout(syncCheckout, 80);
  });
  observer.observe(document.body, {childList: true, characterData: true, subtree: true});
  syncCheckout();
})();
